import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, getFormValues, Field, reset } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import monent from 'moment';
import store from '../../store/redux_store';

import {
  getSizesMale,
  setNewSizesProfileAsDefault,
  createShirtProfileMaleBase,
  saveTemporarySmartSizes,
  cleanSelectedSizeValues,
  changeSizeScenario,
  changeSizeActiveTab,
} from '../../actions/sizes';

import { getUserMaleSize } from '../../selectors/entities/general';
import { getLoginState } from '../../selectors/entities/users';
import { betweenValue } from '../Rules';

import Input from '../ui/Input';
import SizeUtils from '../../utils/sizes';

import {
  ErrorWrapper,
  LabelWrapper,
  LineWrapper,
  SizeListItem,
  SizeTitle,
  SizeList,
  InfoButton,
  ButtonWrapper,
  FormGroup,
  ListWrapper,
  ExpertModeToggle,
  HelpTitle,
  ButtonIcon,
  ButtonLabel,
} from './styled';

import SizeMediaModal from '../Sizes/SizeMediaModal';
import TextIcon from '../ui/icons/forms/TextIcon';


//Если пользователь не ввел имя профиля,
//то выдаем в качестве имени дату в неком формате
const normalizeProfileName = (displayName) => {
  if (!Boolean(displayName)) {
    return monent().format('DD.MM.YYYY HH:mm:ss')
  }
  return displayName;
}

const sizeUtils = new SizeUtils();
const formName = 'measureSizes';

const validateRule = betweenValue(0, 1000);
class MeasureSizeForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
      expretMode: false,
      showMediaModal: false,
    }
  }


  submit = async (values) => {
    if (this.props.loginState) {
      await this.createShirtProfile(values)
    } else {
      await this.saveShirtProfile(values);
    }
  }


  //создать профиль рубашки если пользователь залогинился
  createShirtProfile = async (params) => {
    const { displayName, ...mirrored } = sizeUtils.getMirriored(params);
    const { data } = await this.props.actions.createShirtProfileMaleBase(
      {
        ...params,
        ...mirrored,
        displayName: normalizeProfileName(displayName)
      });


    if (data && data.error_id !== null) {
      this.setState({
        errorMessage: data.error_message,
      });
    }

    if (!this.state.errorMessage && this.props.onAfterSubmit) {
      //устанавливаем созданный профиль размеров в качестве дефолтного
      //По требованиям Натальи Мельниковой
      await this.props.actions.setNewSizesProfileAsDefault(data.profileId);
      this.props.actions.changeSizeScenario('profile');
      this.props.onAfterSubmit();
    }
  }

  //cохранить профиль размеров
  saveShirtProfile = async (params) => {
    const {...mirrored } = sizeUtils.getMirriored(params);  
    await this.props.actions.saveTemporarySmartSizes({...params,...mirrored});
    if (this.props.onAfterSubmit) {
      this.props.actions.changeSizeScenario('measure');
      this.props.onAfterSubmit();
    }
  }

  getSizesMale = async () => {
    const { formValues: { sizeCollar, sizeHeight, sizeWeight } } = this.props;
    await this.props.actions.getSizesMale({ sizeCollar, sizeHeight, sizeWeight });
  }

  renderInput = ({ input }) => {
    const { isMobile } = this.props;
    function handleFocus(event) {
      const target = event.target;
      setTimeout(() => target.select(), 0);
    };

    return (
      <Input
        style={isMobile ? null : { marginBottom: '1.2em' }}

        inputStyle={isMobile ?
          { height: '36px', fontSize: '14px', padding: '0 15px' } : null}
        placeholder='Введите название профиля'  {...input}
        onFocus={handleFocus}
      />
    )
  }
  
  componentDidMount = () => {
    //this.props.actions.formReset();
    //this.props.actions.cleanSelectedSizeValues();
  }


  renderInputFormGroup = ({
    input,
    fieldName,
    hideInfo,
    onInfoButtonClick,
    meta,
    ...others
  }) => {
    const { error, touched } = meta;


    let status = null;
    const showError = error && touched;
    if (showError) {
      status = 'error';
    } else {
      status = null;
    }

    function handleFocus(event) {
      const target = event.target;
      setTimeout(() => target.select(), 0);
    };

    return (
      <SizeListItem hideInfo={hideInfo}>
        <LineWrapper>
          <label>{`${others.displayName}`}</label>
          <LabelWrapper>
            {showError &&
              <ErrorWrapper>{error}</ErrorWrapper>
            }
            <Input
              name={fieldName}
              type='number'
              status={status}
              {...input}
              inputClassName='size-list__input input--text-right'
              onFocus={handleFocus}
              iconRight={
                <TextIcon text={others.units} />
              }
            />
          </LabelWrapper>
        </LineWrapper>
        {!hideInfo &&
          <InfoButton onClick={() => onInfoButtonClick(others)} >?</InfoButton>
        }
      </SizeListItem>
    )
  }

  toggleExpertMode = () => {
    this.setState({
      expretMode: !this.state.expretMode,
    });
  }

  toggleSizeMediaModal = (params) => {
    const { showMediaModal } = this.state;
    let modalParams = null;
    if (!showMediaModal) {
      modalParams = params;
    }
    this.setState({
      modalParams,
      showMediaModal: !showMediaModal
    });
  }

  renderButtonIcon = (src) => (<ButtonIcon src={`/images/builder/${src}`} />)
  
  render() {

    const {
      handleSubmit,
      loginState,
      valid,
      sizeOptions,
      hideInfo,
      containExpertMode
    } = this.props;

    const {
      errorMessage,
      expretMode,
      showMediaModal,
      modalParams,
    } = this.state;

    let filteredValues = [];
    if (expretMode) {
      filteredValues = sizeOptions;
    } else {
      filteredValues = sizeOptions.filter(o => !o.expert);
    }

    let submitButton = null;
    if (loginState) {
      submitButton = (
        <button
          disabled={!valid}
          type="submit"
          className="rit-button rit-button_theme_black rit-button_size_30em"
        >
          Сохранить профиль размеров
        </button>
      );
    } else {
      submitButton = (
        <button
          disabled={!valid}
          type="submit"
          className="rit-button rit-button_theme_black rit-button_size_30em"
        >
          Использовать размеры
        </button>
      );
    }

    let profileInput = null;
    if (loginState) {
      profileInput = (
        <Field
          name='displayName'
          component={this.renderInput}
        //validate={[/* required */]}
        />
      )
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>

        <ListWrapper>
          <SizeTitle>Таблица размеров</SizeTitle>
          <SizeList>
            {
              filteredValues.map((size) => (
                <Field
                  hideInfo={hideInfo}
                  key={size.fieldName}
                  validate={[validateRule]}
                  name={size.fieldName}
                  displayName={size.displayName}
                  onInfoButtonClick={this.toggleSizeMediaModal}
                  component={this.renderInputFormGroup}
                  {...size}
                />
              ))
            }
          </SizeList>

          {containExpertMode &&
            <ExpertModeToggle
              expretMode={expretMode}
              onClick={this.toggleExpertMode}
            >
              Для профессионалов
          </ExpertModeToggle>}

          <FormGroup loginState={loginState}>
            {profileInput}
            <ButtonWrapper>
              {submitButton}
            </ButtonWrapper>
            <ErrorWrapper>
              {errorMessage}
            </ErrorWrapper>
          </FormGroup>

          {containExpertMode &&
            <FormGroup loginState={loginState}>
              <HelpTitle>ВАМ МОЖЕТ ПОНАДОБИТЬСЯ</HelpTitle>
              <ButtonWrapper>
                <a href='https://www.youtube.com/watch?v=GYVw1ovjxSU&list=PLH3q4s4sTjZ28OZ5duLL98TgGWkJ_De4K&ab_channel=Remark1991%E2%80%93%D0%A1%D0%BE%D0%B2%D1%80%D0%B5%D0%BC%D0%B5%D0%BD%D0%BD%D0%B0%D1%8F%D0%BA%D0%BB%D0%B0%D1%81%D1%81%D0%B8%D0%BA%D0%B0%D0%BC%D1%83%D0%B6%D1%81%D0%BA%D0%BE%D0%B9%D0%BC%D0%BE%D0%B4%D1%8B.' target="_blank" rel="noopener noreferrer"> 
                  <button
                    type='button'
                    className='rit-button rit-button_theme_link rit-button_size_full rit-button_text-align_left'>
                    {this.renderButtonIcon('size_button1_24x24.png')}
                    <ButtonLabel>Как снять размеры для сорочки</ButtonLabel>
                  </button>
                </a>

                <a href='/images/pdf/measure_tape.pdf' target="_blank" rel="noopener noreferrer">
                  <button
                    type='button'
                    className='rit-button rit-button_theme_link rit-button_size_full rit-button_text-align_left'>
                    {this.renderButtonIcon('size_button2_24x24.png')}
                    <ButtonLabel>Скачать измерительную ленту</ButtonLabel>
                  </button>
                </a>


                <a href='/images/pdf/measureguide.pdf' target="_blank" rel="noopener noreferrer">
                  <button
                    type='button'
                    className='rit-button rit-button_theme_link rit-button_size_full rit-button_text-align_left'>
                    {this.renderButtonIcon('size_button3_24x24.png')}
                    <ButtonLabel>Скачать инструкцию</ButtonLabel>
                  </button>
                </a>

              </ButtonWrapper>
            </FormGroup>}


          {showMediaModal &&
            <SizeMediaModal
              onClose={this.toggleSizeMediaModal}
              title={modalParams.displayName}
              description={modalParams.help}
              mediaUrl={modalParams.url}
              closeOnEsc={true}
            />
          }

        </ListWrapper>
      </form>
    );
  }
}

MeasureSizeForm.propTypes = {
  hideInfo: PropTypes.bool.isRequired,
  containExpertMode: PropTypes.bool.isRequired,
  sizeOptions: PropTypes.array.isRequired,
  onAfterSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  formValues: PropTypes.object,
  loginState: PropTypes.bool.isRequired,
  actions: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
}

export default connect(
  (state) => {
    const initialValues = {
      height: 0,
      weight: 0,
      collar_size: 0,
      neck: 0,
      chest: 0,
      waist: 0,
      seat: 0,
      shirt_length: 0,
      shoulder_width: 0,
      arm_length: 0,
      armAround: 0,
      wrist: 0,
      hip_bottoms: 0,
      seat_bottoms: 0,
      inseam: 0,
      hip: 0,
      short_sleeve_length: 0,
      biceps: 0,
      sleeve_length_jacket: 0,
      sleeve_length_suit: 0,
      jacket_length: 0,
      sizeCollar: 0,
      sizeHeight: 0,
      sizeWeight: 0,
      displayName: '',
      chestWidth: 0,
      backWidth: 0,
      shoulderWidth: 0,
      dts2: 0,
      shoulderHeightBack: 0,
      shoulderHeightFront: 0,
      waistLengthBack: 0,
      waistLengthFront: 0,
      vprz: 0,
      ...getUserMaleSize(state),
    }
    return {
      initialValues,
      formValues: getFormValues(formName)(state),
      loginState: getLoginState(state),
      isMobile: state.ui.isMobile,
    }
  },
  dispatch => ({
    actions: bindActionCreators(
      {
        getSizesMale,
        setNewSizesProfileAsDefault,
        saveTemporarySmartSizes,
        createShirtProfileMaleBase,
        cleanSelectedSizeValues,
        changeSizeScenario,
        formReset: () => reset(formName),
      }, dispatch)
  }),
)((
  reduxForm({
    form: formName,
    onSubmit: async function(values) {
      const state = store.getState();
      const { dispatch } = store;

      if (state.user.isLogined) {
        const { displayName, ...mirrored } = sizeUtils.getMirriored(values);
        const { data } = await dispatch(createShirtProfileMaleBase({
            ...values,
            ...mirrored,
            displayName: normalizeProfileName(displayName)
          }));

        if (data && data.error_id) {
          alert(data.error_message);
        }
    
        if (!data.error_id) {
          await dispatch(setNewSizesProfileAsDefault(data.profileId));
          dispatch(changeSizeScenario('profile'));
        }
      } else {
        const {...mirrored } = sizeUtils.getMirriored(values);
        dispatch(saveTemporarySmartSizes({...values, ...mirrored}));
        dispatch(changeSizeScenario('measure'));
      }
      await dispatch(changeSizeActiveTab(''));
    },
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
    touchOnChange: true,
    touchOnBlur: true,
  })(MeasureSizeForm))
);
